import React, { useState } from 'react'
import { Avatar, Col, Form, FormInstance, Input, Radio, Row } from 'antd'
import { adminSettingStore } from 'state/setting/admin'
import { myStore } from 'state/store'
import FileUploader from 'helper/FileUploader'
import { validateAlphabets, validatePhone } from 'helper/utility'
import PhoneInput from 'react-phone-input-2'
import { Phone } from 'types/globalTypes'
import { useCreateAdmin } from 'api/Admin'

interface AddAdminFormProps {
  form: FormInstance
}

const AddAdminForm: React.FC<AddAdminFormProps> = ({ form }) => {
  const { adminData, setAdminData, setMailFoundModal, newEmail, setNewEmail } =
    adminSettingStore(store => ({
      adminData: store.adminData,
      setAdminData: store.setAdminData,
      setMailFoundModal: store.setMailFoundModal,
      newEmail: store.newEmail,
      setNewEmail: store.setNewEmail,
    }))
  const [avatar, setAvatar] = useState<string>('')
  const [phone, setPhone] = useState<Phone>({
    dialCode: adminData ? adminData.phone?.dialCode : '',
    isoCode: adminData ? adminData.phone?.isoCode : '',
    number: adminData ? adminData.phone?.number : '',
  })
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const { mutate: createAdmin } = useCreateAdmin()

  const formSchema = {
    photoId: adminData ? adminData?.photoId : undefined,
    firstName: adminData ? adminData?.firstName : undefined,
    lastName: adminData ? adminData?.lastName : undefined,
    email: adminData ? adminData?.email : newEmail,
    gender: adminData ? adminData?.gender : undefined,
    phone: adminData ? adminData?.phone?.number : undefined,
  }

  const onFinish = (values: any) => {
    const payload = { ...values }
    payload.phone = phone.number && phone.number.length > 4 ? phone : undefined
    setModalBtnLoader(true)
    createAdmin(payload, {
      onSuccess: () => {
        setAdminData(null)
        setNewEmail(null)
        setModalBtnLoader(false)
        setMailFoundModal(false)
      },
      onError: () => {
        setModalBtnLoader(false)
      },
    })
  }
  return (
    <>
      <Form
        name="add-admin-form"
        initialValues={formSchema}
        form={form}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
      >
        <Row gutter={24} align="middle">
          <Col span={4} className="mb-10px">
            <Avatar size={80} src={avatar ? avatar : ''}></Avatar>
          </Col>
          <Col span={18} className="">
            <Form.Item name="photoId">
              <FileUploader
                setAvatar={setAvatar}
                name="adult"
                form={form}
                fileId={
                  adminData && adminData?.photoId
                    ? adminData.photoId
                    : undefined
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <p className="text-12 w-400">For security purposes, add a real photo</p>
        <Row gutter={24} className="mt-10px">
          <Col span={12}>
            <label className="input-label required-input">FirstName</label>
            <Form.Item
              colon={false}
              name="firstName"
              rules={[
                { required: true, message: 'First Name required' },
                { validator: validateAlphabets },
              ]}
            >
              <Input placeholder="Enter First Name" required name="firstname" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label className="input-label required-input">Last Name</label>
            <Form.Item
              colon={false}
              name="lastName"
              rules={[
                { required: true, message: 'First Name required' },
                { validator: validateAlphabets },
              ]}
            >
              <Input placeholder="Enter Last Name" name="middleName" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <label className="input-label ">Email</label>
            <Form.Item name="email">
              <Input placeholder="example@gmail.com" name="email" disabled />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <label className="input-label ">Gender</label>
            <Form.Item name="gender">
              <Radio.Group name="gender">
                <Row>
                  <Radio.Button className="radioButton" value="male">
                    <h5>Male</h5>
                  </Radio.Button>
                  <Radio.Button className="radioButton" value="female">
                    <h5>Female</h5>
                  </Radio.Button>
                </Row>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <label className="input-label">Phone number</label>
            <Form.Item
              name="phone"
              className="phone-number-form"
              rules={[{ validator: validatePhone }]}
            >
              <PhoneInput
                country={phone?.isoCode || 'us'}
                onChange={(value: string, data: any) => {
                  setPhone({
                    dialCode: '+' + data?.dialCode,
                    number: '+' + value,
                    isoCode: data.countryCode.toUpperCase(),
                  })
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {!adminData && (
          <Row>
            <Col>
              <label className="input-label required-input">Password</label>
              <Form.Item
                name={'password'}
                className="form-control allergies-field "
                rules={[
                  { required: true, message: 'Password is required' },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve()
                      const complexityRegex = /^(?=.*[A-Z])(?=.*\d).{8,}$/
                      return complexityRegex.test(value)
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              'Password must be at least 8 characters, include 1 uppercase letter and 1 number',
                            ),
                          )
                    },
                  },
                ]}
              >
                <Input.Password
                  className="custom-input-field"
                  placeholder="Enter new password"
                />
              </Form.Item>
            </Col>
          </Row>
        )}
      </Form>
    </>
  )
}

export default AddAdminForm
